import React, { ComponentType } from 'react'
import { Segment } from 'semantic-ui-react'
// Local
import { initCap } from '../../common/formatUtils'
import { Patient } from '../../patient/patient'

const SafeSegment = Segment as unknown as ComponentType<any>

/**
 * Provides a component that renders the encounter source type, if provided
 *
 * @param encounter Encounter entity
 * @param mode Render mode. Default: left
 */

type Props = {
  encounter?: Patient | undefined
  mode?: string | undefined
}

function EncounterSource(
  props: Props
): JSX.Element | null {
  const {
    encounter,
    mode
  } = props

  const renderLeft = () => {
    if (encounter && encounter.sourceCodeType) {
      return (
        <SafeSegment
          attached
          compact
          className="left-segment"
        >
          <div className="left-title">
            Encounter Source:
          </div>
          <div className="left-content">
            { initCap(encounter.sourceCodeType) }
          </div>
        </SafeSegment>
      )
    }
    return null

  }

  const renderMode = mode || 'left'
  if (renderMode === 'left') {
    return renderLeft()
  }
  return null
}

export default EncounterSource
